import React from 'react';

import {
  FormControl,
  Box,
  FormHelperText,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import DATA_CONNECTOR_TYPES from './dataConnectorTypes';

export default function DataConnectorTypeField({
  value,
  error,
  setValue,
  setChanged,
  edit,
}) {
  const handleChange = (event) => {
    const { value: newValue } = event.target;
    if (event.target.value !== value) {
      setChanged();
    }
    setValue(newValue);
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <InputLabel id='type-label'>Type</InputLabel>
        <Select
          labelId='type-label'
          id='type'
          value={value}
          label='Type'
          aria-describedby='type-helper-text'
          onChange={handleChange}
          disabled={edit}
          error={Boolean(error)}
        >
          <MenuItem value={DATA_CONNECTOR_TYPES.CUSTOM}>Custom</MenuItem>
        </Select>
        {error ? (
          <FormHelperText id='type-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='type-helper-text'>
            Select the type of regional data connector
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}
